import { h } from 'preact'
import PropTypes from 'prop-types'
import { useState } from 'preact/compat'
import { dispatchMFEEvent } from '../app/helpers/events'
import { config } from '../app/config'
import { useMfeAttributeValidation } from './mfeAttributeValidation'
import App from '../app'

export default function TUIPayments({
  components,
  token,
  lang,
  theme,
  amount,
  isPaymentBlocked,
  availablePaymentMethods,
  selectedPaymentMethod,
  stylesHref,
  paypalButtonStyle,
  paypalcreditButtonStyle,
  showHoursInTimer,
  showPaymentConfirmation,
  metadata,
  loaderImage,
}) {
  const [currentTheme, setCurrentTheme] = useState(theme || 'tui-light')

  useMfeAttributeValidation({
    components,
    token,
    lang,
    theme,
    isPaymentBlocked,
    availablePaymentMethods,
    selectedPaymentMethod,
    stylesHref,
    paypalButtonStyle,
    paypalcreditButtonStyle,
    showHoursInTimer,
    showPaymentConfirmation,
    metadata,
    loaderImage,
  })

  return (
    <div
      data-theme={currentTheme}
      className="opp-theme-override payment-opp-root"
      id="payment-opp-root"
    >
      {stylesHref && (
        <link rel="stylesheet" type="text/css" href={stylesHref} />
      )}

      <link
        rel="stylesheet"
        type="text/css"
        href={`${config.baseURL}tui-payments-opp.css`}
      />
      <App
        {...{
          components,
          token,
          lang,
          amount,
          isPaymentBlocked,
          metadata,
          stylesHref,
          paypalButtonStyle,
          paypalCreditButtonStyle: paypalcreditButtonStyle,
          availableTenantPaymentMethods: availablePaymentMethods,
          selectedTenantPaymentMethod: selectedPaymentMethod,
          showPaymentConfirmation: showPaymentConfirmation === 'true',
          showHoursInTimer,
          loaderImage,
          currentTheme,
          attributeThemeValue: theme,
          setCurrentTheme,
        }}
      />
    </div>
  )
}

TUIPayments.propTypes = {
  components: PropTypes.string,
  token: PropTypes.string,
  lang: PropTypes.string,
  theme: PropTypes.string,
  amount: PropTypes.string,
  isPaymentBlocked: PropTypes.string,
  availablePaymentMethods: PropTypes.string,
  selectedPaymentMethod: PropTypes.string,
  stylesHref: PropTypes.string,
  paypalButtonStyle: PropTypes.string,
  paypalcreditButtonStyle: PropTypes.string,
  showHoursInTimer: PropTypes.string,
  showPaymentConfirmation: PropTypes.string,
  loaderImage: PropTypes.string,
}
